import { Box, Typography } from "@mui/material";
import PriestAvailabilitySchedule from "../PriestAvailabilitySchedule/PriestAvailabilitySchedule";
import MySchedule from "../MySchedule/MySchedule";

const ViewPriestSchedule = ({ isHallSchedule = false }) => {
  return (
    <Box>
      <Typography className="sub_heading">View {isHallSchedule ? "Hall": "Priest"} Schedule</Typography>
      <MySchedule isViewPriestSchedule={true} isHallSchedule={isHallSchedule}/>
      <Box sx={{ mt: "15px" }}>
        <PriestAvailabilitySchedule
          isViewPriestSchedule={true}
          isHallSchedule={isHallSchedule}
        />
      </Box>
    </Box>
  );
};

export default ViewPriestSchedule;
